webpackJsonp([35],{

/***/ "EStm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/salma-webinars_9928f481310ddc1558c335ae54f402e3.html";

/***/ }),

/***/ "MnpC":
/***/ (function(module, exports, __webpack_require__) {

var salmaWebinars = (function () {
    function salmaWebinars() {
    }
    return salmaWebinars;
}());
angular.module('animatronApp.wave.salmaWebinars', []).component('salmaWebinars', {
    controller: salmaWebinars,
    templateUrl: __webpack_require__("EStm")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/35-c7c98a0cc108ea8b91f3.min.js